var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReason(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.23153 19.7111L5.17396 20.0455L5.34492 19.5638L5.05449 19.143L4.23153 19.7111ZM2 26L1.05757 25.6656L0.408525 27.4947L2.27472 26.9615L2 26ZM9.33773 23.9035L9.73387 22.9853L9.40618 22.8439L9.06301 22.942L9.33773 23.9035ZM25 12.9375C25 18.9781 20.1031 23.875 14.0625 23.875V25.875C21.2077 25.875 27 20.0827 27 12.9375H25ZM14.0625 2C20.1031 2 25 6.89689 25 12.9375H27C27 5.79232 21.2077 0 14.0625 0V2ZM3.125 12.9375C3.125 6.89689 8.02189 2 14.0625 2V0C6.91732 0 1.125 5.79232 1.125 12.9375H3.125ZM5.05449 19.143C3.83757 17.3802 3.125 15.2436 3.125 12.9375H1.125C1.125 15.6623 1.96847 18.1931 3.40858 20.2792L5.05449 19.143ZM2.94243 26.3344L5.17396 20.0455L3.2891 19.3767L1.05757 25.6656L2.94243 26.3344ZM9.06301 22.942L1.72528 25.0385L2.27472 26.9615L9.61245 24.865L9.06301 22.942ZM14.0625 23.875C12.5229 23.875 11.0601 23.5575 9.73387 22.9853L8.9416 24.8217C10.5133 25.4998 12.2454 25.875 14.0625 25.875V23.875Z",
    fill: "#FFAA20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.21277 12.1915L14.1915 9.06384L19.3617 12.1915",
    stroke: "#FFAA20",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.21277 16.4043L14.1915 13.2766L19.3617 16.4043",
    stroke: "#FFAA20",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReason);
export default __webpack_public_path__ + "static/media/reason.6fe9c4eb736850119078a1697f17dd7b.svg";
export { ForwardRef as ReactComponent };